import { render, staticRenderFns } from "./AscPlotFooter.vue?vue&type=template&id=166744b0&"
import script from "./AscPlotFooter.vue?vue&type=script&lang=js&"
export * from "./AscPlotFooter.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports